import { memo } from 'react'
import { Field } from 'root/src/client/web/form/FormModule/Field'

const Fields = memo(({
	formFieldTypes, moduleKey, formType, wasSubmitted,
	moduleId, stepId, onBlur, onClick, doubleColumn,
	inputHeight, fieldTheme,
}) => formFieldTypes.map(([
	fieldPath,
	fieldDescPath,
	inputType,
	fieldId,
	subFieldText,
	labelFieldText,
	fieldValue,
	fieldMax,
	subTextLabel,
	fieldFullWidth,
	fieldActionButton,
	fieldHalfWidth,
	fieldStorePath,
	variantOptions,
	optionsPromiseType,
	locked,
	fieldDefault,
	fieldOnExit,
	breakpointItems,
	crop,
	over,
	hideInput,
	isMultiGame,
	customFieldProps,
	fieldToggle,
	asyncOptionsStoreKey,
	clearFormInputs,
	imageConstraints,
	column,
]) => {
	const wrapperProps = {
		subFieldText,
		labelFieldText,
		key: fieldId,
		formType,
		subTextLabel,
		fieldHalfWidth,
		doubleColumn,
		over,
		fieldTheme,
		hideInput,
	}
	const props = {
		fieldType: inputType,
		fieldId,
		fieldDescPath,
		moduleKey,
		fieldPath,
		formType,
		fieldValue,
		stepId,
		fieldMax,
		wasSubmitted,
		moduleId,
		onBlur,
		onClick,
		fieldFullWidth,
		fieldActionButton,
		fieldStorePath,
		optionsPromiseType,
		variantOptions,
		locked,
		fieldDefault,
		inputHeight,
		onExit: fieldOnExit,
		breakpointItems,
		crop,
		fieldTheme,
		hideInput,
		isMultiGame,
		customFieldProps,
		asyncOptionsStoreKey,
		clearFormInputs,
		column,
		fieldToggle,
		imageConstraints,
	}
	// TODO move error from field itself, to error wrapper
	return <Field inputType={inputType} props={props} wrapperProps={wrapperProps} />
}))

export default Fields
